export default __webpack_public_path__ + "static/media/upload-circle.4219a715.svg";